import { supabase } from './supabase'

/**
 * Log an audit event to the audit_logs table.
 *
 * @param {Object} params
 * @param {'change'|'login'|'system'} params.category
 * @param {string} params.action - e.g. 'policy.published', 'user.login'
 * @param {string} params.description - Human-readable description
 * @param {string} [params.clientId] - Associated client UUID
 * @param {string} [params.clientName] - Client display name
 * @param {string} [params.resourceType] - e.g. 'policy', 'assessment', 'client'
 * @param {string} [params.resourceId] - UUID of the affected resource
 * @param {Object} [params.metadata] - Extra structured data
 */
export async function logAuditEvent({
  category = 'change',
  action,
  description,
  clientId,
  clientName,
  resourceType,
  resourceId,
  metadata = {}
}) {
  try {
    const { data: { user } } = await supabase.auth.getUser()
    if (!user) return

    // Get profile for role + email
    const { data: profile } = await supabase
      .from('profiles')
      .select('email, role')
      .eq('id', user.id)
      .single()

    await supabase.from('audit_logs').insert({
      user_id: user.id,
      user_email: profile?.email || user.email,
      user_role: profile?.role || 'admin',
      action,
      category,
      client_id: clientId || null,
      client_name: clientName || null,
      resource_type: resourceType || null,
      resource_id: resourceId || null,
      description,
      metadata
    })
  } catch (err) {
    // Audit logging should never break the app
    console.error('Audit log failed:', err)
  }
}
